import { decodeToken, getValidAuthToken } from '@/utils/auth';

// Admin (cargo de maior hierarquia) e master usam a aba mesmo sem a permissão marcada no cargo;
// os demais precisam de flow_sensor:view / flow_sensor:manage. O servidor aplica a mesma regra.
export function useFlowSensorAccess() {
  const token = getValidAuthToken();
  const decoded = token ? decodeToken(token) : null;
  const scopes = decoded?.scope ?? [];
  const privileged = decoded?.isAdmin === true || decoded?.isMaster === true;
  return {
    canView: privileged || scopes.includes('flow_sensor:view'),
    canManage: privileged || scopes.includes('flow_sensor:manage'),
  };
}
